<template>
  <div class="address-input-container" v-if="visible">
    <div class="search-bar">
      <div class="back-btn" @click="handleBack">
        <img src="@assets/images/icon_back.svg" />
      </div>
      <div class="search-input">
        <input
          placeholder="请填写设备安装的详细地址"
          v-model="address"
          ref="search-input"
        />
        <img
          src="@assets/images/icon_close.svg"
          v-if="address"
          class="clear-icon"
          @click="handleClear"
        />
      </div>
      <div class="confirm-btn" @click="handleConfirm">确定</div>
    </div>
    <poi-list
      :pois="poiList"
      :highlightString="address"
      @selectPoi="handleSelectPoi"
    />
  </div>
</template>
<script>
import { debounce } from 'lodash';
// 已迁移至百度地图
import bmapService, { BMAP_CONTAINER_ID } from '@stores/location/bmap';
import PoiList from '../PoiList/PoiList.vue';
export default _extend({
  name: 'AddressInput',
  components: {
    PoiList
  },
  data: function() {
    return {
      address: '',
      BMAP_CONTAINER_ID,
      poiList: [],
      amapInstance: bmapService // 保持变量名兼容
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleSelectPoi(poi) {
      // 通过逆地理编码补充省市区信息
      const enrichedPoi = await this.amapInstance.enrichPoiWithAddress(poi);
      this.$emit('selectPoi', enrichedPoi);
    },
    handleBack() {
      this.$emit('back');
    },
    handleConfirm() {
      this.$emit('confirm', this.address);
    },
    handleClear() {
      this.address = '';
    }
  },
  watch: {
    address: debounce(function(val) {
      if (!val) return;
      this.amapInstance.search(val, (status, result) => {
        if (status === 'complete') {
          this.poiList = result.poiList.pois;
        }
      });
    }, 500),
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs['search-input'].focus();
        });
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.address-input-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f5f6f9;
  display: flex;
  flex-direction: column;
  .search-bar {
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #4981f2;
    display: flex;
    align-items: center;
    padding: 0 22px 0 21px;
    flex: 0 0 auto;
    .back-btn {
      flex: 0 0 auto;
      img {
        width: 25px;
        height: 24px;
      }
    }
    .search-input {
      flex: 1;
      margin-left: 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
      input {
        caret-color: #4981f2;
        width: 100%;
        height: 22px;
        border: none;
        background-color: transparent;
        font-size: 16px;
        color: #333333;
        &::placeholder {
          color: #cccccc;
        }
      }
      .clear-icon {
        margin: 0 16px;
        width: 16px;
        height: 16px;
      }
    }
    .confirm-btn {
      color: #4981f2;
      font-size: 16px;
      flex: 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveForm/AddressInput/AddressInput.vue